var _defs, _rect, _g, _path, _path2, _path3, _path4, _path5, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191,
    height: 57,
    viewBox: "0 0 191 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 6.614,
    x2: -0.383,
    y2: 5.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 17.098,
    x2: -1.305,
    y2: 17.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    y1: 10.863,
    x2: -0.501,
    y2: 9.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 13.583,
    x2: 0.421,
    y2: 12.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(-10 -9.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(10 10)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 191,
    height: 57,
    rx: 5,
    transform: "translate(0 -0.407)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_749-2",
    "data-name": "Group 749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M193.926,11.132a5.949,5.949,0,0,1,5.942,5.942V59.518a5.949,5.949,0,0,1-5.942,5.942H17.074a5.949,5.949,0,0,1-5.942-5.942V17.074a5.949,5.949,0,0,1,5.942-5.942H193.926m0-1.132H17.074A7.1,7.1,0,0,0,10,17.074V59.518a7.1,7.1,0,0,0,7.074,7.074H193.926A7.1,7.1,0,0,0,201,59.518V17.074A7.1,7.1,0,0,0,193.926,10Z",
    transform: "translate(-10 -10)",
    fill: "#a6a6a6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M89.375,33.7a6.017,6.017,0,1,0,6.04,6.017A5.931,5.931,0,0,0,89.375,33.7Zm0,9.663a3.656,3.656,0,1,1,3.4-3.646A3.481,3.481,0,0,1,89.375,43.367ZM76.2,33.7a6.017,6.017,0,1,0,6.04,6.017A5.931,5.931,0,0,0,76.2,33.7Zm0,9.663a3.656,3.656,0,1,1,3.4-3.646A3.481,3.481,0,0,1,76.2,43.367ZM60.524,35.55V38.1h6.108a5.327,5.327,0,0,1-1.389,3.213,6.254,6.254,0,0,1-4.718,1.869,6.792,6.792,0,0,1,0-13.584,6.508,6.508,0,0,1,4.6,1.824l1.8-1.8a8.907,8.907,0,0,0-6.4-2.576,9.347,9.347,0,1,0,0,18.691,8.54,8.54,0,0,0,6.518-2.622,8.435,8.435,0,0,0,2.211-5.972,8.247,8.247,0,0,0-.137-1.594Zm64.1,1.982a5.593,5.593,0,0,0-5.151-3.828,5.717,5.717,0,0,0-5.675,6.017,5.888,5.888,0,0,0,5.972,6.017,5.984,5.984,0,0,0,5.014-2.667L122.735,41.7a3.437,3.437,0,0,1-2.963,1.664,3.063,3.063,0,0,1-2.919-1.822l8.046-3.329Zm-8.206,2.006a3.3,3.3,0,0,1,3.145-3.51A2.328,2.328,0,0,1,121.8,37.3Zm-6.541,5.835h2.643V27.685H109.88Zm-4.332-10.325h-.091a4.171,4.171,0,0,0-3.168-1.344,6.023,6.023,0,0,0,0,12.034,4.1,4.1,0,0,0,3.168-1.368h.091v.867c0,2.3-1.229,3.533-3.213,3.533A3.33,3.33,0,0,1,99.3,46.627l-2.3.958a5.734,5.734,0,0,0,5.334,3.555c3.1,0,5.721-1.824,5.721-6.268v-10.8h-2.508Zm-3.031,8.319a3.66,3.66,0,0,1,0-7.293,3.391,3.391,0,0,1,3.213,3.67A3.361,3.361,0,0,1,102.517,43.367Zm34.495-15.68h-6.326V45.373h2.639v-6.7h3.687a5.5,5.5,0,1,0,0-10.986Zm.068,8.524h-3.755V30.148h3.755a3.032,3.032,0,1,1,0,6.062Zm16.316-2.54a4.959,4.959,0,0,0-4.711,2.707l2.344.979a2.5,2.5,0,0,1,2.412-1.3,2.542,2.542,0,0,1,2.776,2.276v.181a5.839,5.839,0,0,0-2.753-.682c-2.525,0-5.1,1.388-5.1,3.981,0,2.367,2.071,3.892,4.392,3.892a3.725,3.725,0,0,0,3.369-1.73h.091v1.365h2.548V38.562C158.764,35.423,156.422,33.671,153.4,33.671Zm-.318,9.693c-.866,0-2.071-.432-2.071-1.5,0-1.365,1.5-1.889,2.8-1.889a4.71,4.71,0,0,1,2.412.591A3.2,3.2,0,0,1,153.077,43.364Zm14.972-9.307-3.026,7.668h-.091l-3.141-7.668h-2.844l4.71,10.717-2.685,5.962h2.753l7.259-16.679ZM144.27,45.373h2.64V27.686h-2.64Z",
    transform: "translate(7.025 -2.929)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(14.11 10.103)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M20.627,17.568a2.84,2.84,0,0,0-.654,1.988v31.29a2.837,2.837,0,0,0,.654,1.988l.1.1L38.259,35.408v-.413L20.731,17.465Z",
    transform: "translate(-19.973 -17.006)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M38.741,37.828,32.9,31.982v-.413l5.845-5.845.132.076L45.8,29.734c1.976,1.123,1.976,2.961,0,4.085l-6.923,3.933Z",
    transform: "translate(-14.612 -13.58)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M44.044,35.977,38.068,30,20.435,47.634c.652.69,1.729.775,2.941.086L44.044,35.977",
    transform: "translate(-19.781 -11.806)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M44.044,29.36,23.376,17.617c-1.212-.689-2.289-.6-2.941.086L38.068,35.336Z",
    transform: "translate(-19.781 -17.14)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(0 24.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M43.912,34.132,23.376,45.8a2.356,2.356,0,0,1-2.835.016h0l-.106.1h0l.1.1h0a2.356,2.356,0,0,0,2.835-.016L44.044,34.264Z",
    transform: "translate(-19.781 -34.132)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M20.627,42.9a2.837,2.837,0,0,1-.654-1.988v.208a2.833,2.833,0,0,0,.654,1.986l.106-.1Z",
    transform: "translate(-19.973 -31.319)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M44.083,31.837l-7.054,4.008.132.132,6.923-3.933A2.484,2.484,0,0,0,45.566,30h0A2.633,2.633,0,0,1,44.083,31.837Z",
    transform: "translate(-12.898 -11.806)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M23.568,17.823,51.158,33.5a2.633,2.633,0,0,1,1.483,1.836h0a2.48,2.48,0,0,0-1.483-2.043L23.568,17.617c-1.978-1.123-3.6-.19-3.6,2.074V19.9C19.973,17.634,21.59,16.7,23.568,17.823Z",
    transform: "translate(-19.973 -17.14)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(68.401 19.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M51.278,25.489V17h2.6a4.22,4.22,0,0,1,3.131,1.18,4.155,4.155,0,0,1,1.173,3.064,4.158,4.158,0,0,1-1.173,3.064,4.22,4.22,0,0,1-3.131,1.18Zm1.091-1.043h1.505a3.205,3.205,0,1,0,0-6.4H52.369Z",
    transform: "translate(-51.278 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M57.237,25.489V17h1.091v8.489Z",
    transform: "translate(-48.806 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M61.943,25.734a3.163,3.163,0,0,1-1.807-.6,2.787,2.787,0,0,1-1.156-1.7l1-.4A2.279,2.279,0,0,0,60.7,24.21a1.843,1.843,0,0,0,1.239.48,1.989,1.989,0,0,0,1.217-.372,1.2,1.2,0,0,0,.5-1.014,1.3,1.3,0,0,0-.5-1.1,5.235,5.235,0,0,0-1.594-.717,4.237,4.237,0,0,1-1.708-.92,1.916,1.916,0,0,1-.581-1.44A2.1,2.1,0,0,1,60,17.542a2.647,2.647,0,0,1,1.885-.676,2.731,2.731,0,0,1,1.756.539,2.5,2.5,0,0,1,.877,1.18L63.522,19a1.476,1.476,0,0,0-.529-.747,1.855,1.855,0,0,0-2.158.007,1.065,1.065,0,0,0-.444.87.988.988,0,0,0,.409.8,3.94,3.94,0,0,0,1.2.587,10.048,10.048,0,0,1,1.05.392,4.748,4.748,0,0,1,.853.5,2,2,0,0,1,.652.782,2.538,2.538,0,0,1,.219,1.084,2.341,2.341,0,0,1-.253,1.1,2.1,2.1,0,0,1-.678.771,3.409,3.409,0,0,1-1.9.58Z",
    transform: "translate(-48.083 -16.866)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M65.273,25.489H64.184V17h2.893a2.682,2.682,0,0,1,1.866.717,2.468,2.468,0,0,1,0,3.616,2.682,2.682,0,0,1-1.866.717h-1.8Zm0-4.482H67.1a1.406,1.406,0,0,0,1.1-.461,1.461,1.461,0,0,0,0-2.039,1.4,1.4,0,0,0-1.1-.464H65.273Z",
    transform: "translate(-45.924 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M76.174,24.448a4.408,4.408,0,0,1-6.224,0,4.587,4.587,0,0,1,0-6.3,4.4,4.4,0,0,1,6.22.006,4.574,4.574,0,0,1,0,6.29Zm-5.419-.712a3.265,3.265,0,0,0,4.612,0,3.322,3.322,0,0,0,.944-2.436,3.322,3.322,0,0,0-.944-2.436,3.265,3.265,0,0,0-4.612,0,3.327,3.327,0,0,0-.942,2.436A3.327,3.327,0,0,0,70.756,23.736Z",
    transform: "translate(-44.051 -16.866)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M75.949,25.489V17h1.329L81.4,23.6h.047L81.4,21.967V17h1.091v8.489H81.356L77.04,18.565h-.048L77.04,20.2v5.287Z",
    transform: "translate(-41.044 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M81.949,25.489V17H83.04v8.489Z",
    transform: "translate(-38.555 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M84.094,25.489V17h3.07a2.488,2.488,0,0,1,1.725.658,2.133,2.133,0,0,1,.73,1.654,1.843,1.843,0,0,1-.316,1.067,1.965,1.965,0,0,1-.836.7v.047a2.164,2.164,0,0,1,1.033.734,1.939,1.939,0,0,1,.4,1.211,2.226,2.226,0,0,1-.765,1.73,2.613,2.613,0,0,1-1.808.688Zm1.089-4.85h1.981a1.27,1.27,0,0,0,.99-.409,1.264,1.264,0,0,0,.011-1.783,1.219,1.219,0,0,0-.954-.4H85.183Zm0,3.807h2.194a1.3,1.3,0,0,0,1.02-.44,1.411,1.411,0,0,0,.39-.961,1.429,1.429,0,0,0-1.459-1.387H85.183Z",
    transform: "translate(-37.665 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M89.239,25.489V17H90.33v7.446H94v1.043Z",
    transform: "translate(-35.531 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M98.536,18.043H94.671v2.692h3.486v1.019H94.671v2.692h3.865v1.043H93.58V17h4.956Z",
    transform: "translate(-33.731 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M102.611,25.734a3.163,3.163,0,0,1-1.807-.6,2.8,2.8,0,0,1-1.157-1.7l1-.4a2.261,2.261,0,0,0,.727,1.179,1.843,1.843,0,0,0,1.239.48,1.989,1.989,0,0,0,1.217-.372,1.2,1.2,0,0,0,.5-1.014,1.3,1.3,0,0,0-.5-1.1,5.235,5.235,0,0,0-1.594-.717,4.237,4.237,0,0,1-1.708-.92,1.917,1.917,0,0,1-.583-1.44,2.1,2.1,0,0,1,.724-1.587,2.647,2.647,0,0,1,1.885-.676,2.725,2.725,0,0,1,1.754.539,2.485,2.485,0,0,1,.877,1.18l-.995.415a1.465,1.465,0,0,0-.528-.747,1.855,1.855,0,0,0-2.158.007,1.067,1.067,0,0,0-.446.87.99.99,0,0,0,.41.8,3.94,3.94,0,0,0,1.2.587,10.047,10.047,0,0,1,1.05.392,4.748,4.748,0,0,1,.853.5,2,2,0,0,1,.652.782,2.538,2.538,0,0,1,.219,1.084,2.342,2.342,0,0,1-.255,1.1,2.086,2.086,0,0,1-.676.771,3.409,3.409,0,0,1-1.9.58Z",
    transform: "translate(-31.214 -16.866)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M107.858,25.678a2.976,2.976,0,0,1-2.271-.925,3.382,3.382,0,0,1-.87-2.418V17h1.089v5.383a2.435,2.435,0,0,0,.528,1.63,2.18,2.18,0,0,0,3.048,0,2.435,2.435,0,0,0,.528-1.63V17H111v5.335a3.433,3.433,0,0,1-.847,2.424A2.968,2.968,0,0,1,107.858,25.678Z",
    transform: "translate(-29.111 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M110.4,25.489V17h2.893a2.683,2.683,0,0,1,1.868.717,2.442,2.442,0,0,1,.207,3.379,2.51,2.51,0,0,1-1.446.86l-.024.035,2.384,3.451v.047h-1.292L112.7,22.051h-1.21v3.438Zm1.091-4.458h1.754a1.606,1.606,0,0,0,1.121-.427,1.392,1.392,0,0,0,.468-1.078,1.487,1.487,0,0,0-.415-1.019,1.4,1.4,0,0,0-1.1-.464h-1.827Z",
    transform: "translate(-26.754 -16.81)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFr);
export default __webpack_public_path__ + "static/media/google-fr.be629f243d1160a2d4642c1d7f621005.svg";
export { ForwardRef as ReactComponent };